import React from "react";
import { toast } from "sonner";
import { faCircleCheck, faCircleExclamation, faTriangleExclamation, } from "@fortawesome/pro-solid-svg-icons";
import { FaIcon } from "../fa-icon/fa-icon";
const buildSonnerOptions = (icon, options) => {
    const sonnerOptions = {};
    if (icon !== undefined) {
        sonnerOptions.icon = icon;
    }
    if (options?.action) {
        sonnerOptions.action = options.action;
    }
    if (options?.id !== undefined) {
        sonnerOptions.id = options.id;
    }
    return sonnerOptions;
};
const showToastImpl = (message, options) => {
    toast(message, buildSonnerOptions(undefined, options));
};
const success = (message, options) => {
    toast.success(message, buildSonnerOptions(React.createElement(FaIcon, { icon: faCircleCheck }), options));
};
const warning = (message, options) => {
    toast.warning(message, buildSonnerOptions(React.createElement(FaIcon, { icon: faTriangleExclamation }), options));
};
const error = (message, options) => {
    toast.error(message, buildSonnerOptions(React.createElement(FaIcon, { icon: faCircleExclamation }), options));
};
const neutral = (message, options) => {
    toast(message, buildSonnerOptions(undefined, options));
};
const special = (message, options) => {
    // No leading icon — the blue chrome (border + halo + tinted surface)
    // is the entire visual signal for the special status. Keeps the pill
    // text-forward, the way neutral toasts read, but in the brand blue.
    toast.info(message, buildSonnerOptions(undefined, options));
};
export const showToast = Object.assign(showToastImpl, {
    success,
    warning,
    error,
    neutral,
    special,
});
